var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90833 8.48323V16.5916C3.90833 18.1749 5.03333 18.8249 6.39999 18.0416L8.35833 16.9249C8.78333 16.6832 9.49166 16.6582 9.93333 16.8832L14.3083 19.0749C14.75 19.2916 15.4583 19.2749 15.8833 19.0332L19.4917 16.9666C19.95 16.6999 20.3333 16.0499 20.3333 15.5166V7.40823C20.3333 5.8249 19.2083 5.1749 17.8417 5.95823L15.8833 7.0749C15.4583 7.31657 14.75 7.34156 14.3083 7.11656L9.93333 4.93323C9.49166 4.71656 8.78333 4.73323 8.35833 4.9749L4.74999 7.04157C4.28333 7.30823 3.90833 7.95823 3.90833 8.48323Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13342 5.33325V16.1666",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1083 7.51685V18.6668",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.7aae87a524f67c3c94e15cb39ab65e0b.svg";
export { ForwardRef as ReactComponent };